import { useRef, useState } from "react";
import { Check, Pencil, Plus, X } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

/**
 * Editor a tag: un valore per volta, con aggiunta, modifica e rimozione singola.
 */
export default function TagListEditor({ values = [], onChange, placeholder = "Aggiungi e premi Invio" }) {
  const inputRef = useRef(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState("");

  const add = () => {
    const v = inputRef.current?.value?.trim() ?? "";
    if (!v) return;
    onChange([...values, v]);
    if (inputRef.current) inputRef.current.value = "";
  };

  const remove = (i) => onChange(values.filter((_, idx) => idx !== i));

  const startEdit = (i) => {
    setEditingIndex(i);
    setEditValue(values[i] ?? "");
  };

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditValue("");
  };

  const saveEdit = () => {
    const v = editValue.trim();
    if (!v || editingIndex === null) return;
    const next = [...values];
    next[editingIndex] = v;
    onChange(next);
    cancelEdit();
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {values.map((v, i) =>
          editingIndex === i ? (
            <div key={i} className="inline-flex items-center gap-1">
              <Input
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    saveEdit();
                  }
                  if (e.key === "Escape") cancelEdit();
                }}
                className="h-8 text-sm w-40"
                autoFocus
              />
              <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={saveEdit}>
                <Check className="w-3.5 h-3.5 text-emerald-600" />
              </Button>
              <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={cancelEdit}>
                <X className="w-3.5 h-3.5 text-slate-400" />
              </Button>
            </div>
          ) : (
            <span
              key={i}
              className="inline-flex items-center gap-1 bg-slate-100 text-slate-700 text-sm px-2 py-1 rounded-full"
            >
              {v}
              <button
                type="button"
                onClick={() => startEdit(i)}
                className="text-slate-400 hover:text-blue-600"
                aria-label={`Modifica ${v}`}
              >
                <Pencil className="w-3 h-3" />
              </button>
              <button
                type="button"
                onClick={() => remove(i)}
                className="text-slate-400 hover:text-red-500"
                aria-label={`Rimuovi ${v}`}
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          )
        )}
      </div>
      <div className="flex gap-2">
        <Input
          ref={inputRef}
          defaultValue=""
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
          placeholder={placeholder}
          className="h-8 text-sm"
        />
        <Button type="button" variant="outline" size="sm" onClick={add} className="shrink-0">
          <Plus className="w-3 h-3 mr-1" />
          Aggiungi
        </Button>
      </div>
    </div>
  );
}
